webpackJsonp([173],{

/***/ 1025:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllBatchJobsTable_vue__ = __webpack_require__(2542);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b924f7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllBatchJobsTable_vue__ = __webpack_require__(3291);
function injectStyle (ssrContext) {
  __webpack_require__(3289)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b924f7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllBatchJobsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b924f7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllBatchJobsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.download = factory();
  }
}(this, function () {

	return function download(data, strFileName, strMimeType) {

		var self = window, // this script is only for browsers anyway...
			defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
			mimeType = strMimeType || defaultMime,
			payload = data,
			url = !strFileName && !strMimeType && payload,
			anchor = document.createElement("a"),
			toString = function(a){return String(a);},
			myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
			fileName = strFileName || "download",
			blob,
			reader;
			myBlob= myBlob.call ? myBlob.bind(self) : Blob ;
	  
		if(String(this)==="true"){ //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
			payload=[payload, mimeType];
			mimeType=payload[0];
			payload=payload[1];
		}


		if(url && url.length< 2048){ // if no filename and no mime, assume a url was passed as the only argument
			fileName = url.split("/").pop().split("?")[0];
			anchor.href = url; // assign href prop to temp anchor
		  	if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
        		var ajax=new XMLHttpRequest();
        		ajax.open( "GET", url, true);
        		ajax.responseType = 'blob';
        		ajax.onload= function(e){ 
				  download(e.target.response, fileName, defaultMime);
				};
        		setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
			    return ajax;
			} // end if valid url?
		} // end if url?


		//go ahead and download dataURLs right away
		if(/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)){
		
			if(payload.length > (1024*1024*1.999) && myBlob !== toString ){
				payload=dataUrlToBlob(payload);
				mimeType=payload.type || defaultMime;
			}else{			
				return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
					navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
					saver(payload) ; // everyone else can save dataURLs un-processed
			}
			
		}else{//not data url, is it a string with special needs?
			if(/([\x80-\xff])/.test(payload)){			  
				var i=0, tempUiArr= new Uint8Array(payload.length), mx=tempUiArr.length;
				for(i;i<mx;++i) tempUiArr[i]= payload.charCodeAt(i);
			 	payload=new myBlob([tempUiArr], {type: mimeType});
			}		  
		}
		blob = payload instanceof myBlob ?
			payload :
			new myBlob([payload], {type: mimeType}) ;


		function dataUrlToBlob(strUrl) {
			var parts= strUrl.split(/[:;,]/),
			type= parts[1],
			decoder= parts[2] == "base64" ? atob : decodeURIComponent,
			binData= decoder( parts.pop() ),
			mx= binData.length,
			i= 0,
			uiArr= new Uint8Array(mx);

			for(i;i<mx;++i) uiArr[i]= binData.charCodeAt(i);

			return new myBlob([uiArr], {type: type});
		 }

		function saver(url, winMode){

			if ('download' in anchor) { //html5 A[download]
				anchor.href = url;
				anchor.setAttribute("download", fileName);
				anchor.className = "download-js-link";
				anchor.innerHTML = "downloading...";
				anchor.style.display = "none";
				document.body.appendChild(anchor);
				setTimeout(function() {
					anchor.click();
					document.body.removeChild(anchor);
					if(winMode===true){setTimeout(function(){ self.URL.revokeObjectURL(anchor.href);}, 250 );}
				}, 66);
				return true;
			}

			// handle non-a[download] safari as best we can:
			if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
				if(/^data:/.test(url))	url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				if(!window.open(url)){ // popup blocked, offer direct download:
					if(confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){ location.href=url; }
				}
				return true;
			}

			//do iframe dataURL download (old ch+FF):
			var f = document.createElement("iframe");
			document.body.appendChild(f);

			if(!winMode && /^data:/.test(url)){ // force a mime that will download:
				url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
			}
			f.src=url;
			setTimeout(function(){ document.body.removeChild(f); }, 333);

		}//end saver




		if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
			return navigator.msSaveBlob(blob, fileName);
		}

		if(self.URL){ // simple fast and modern way using Blob and URL:
			saver(self.URL.createObjectURL(blob), true);
		}else{
			// handle non-Blob()+non-URL browsers:
			if(typeof blob === "string" || blob.constructor===toString ){
				try{
					return saver( "data:" +  mimeType   + ";base64,"  +  self.btoa(blob)  );
				}catch(y){
					return saver( "data:" +  mimeType   + "," + encodeURIComponent(blob)  );
				}
			}

			// Blob but not URL support:
			reader=new FileReader();
			reader.onload=function(e){
				saver(this.result);
			};
			reader.readAsDataURL(blob);
		}
		return true;
	}; /* end download() */
}));


/***/ }),

/***/ 1388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SjProgress',
  data: function data() {
    return {
      type: 'line'
    };
  },

  props: {
    percentages: {
      type: Array,
      default: []
    },
    strokeWidth: {
      type: Number,
      default: 6
    },
    textInside: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: true
    },
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    barParts: function barParts() {
      var result = [];
      for (var i in this.percentages) {
        if (this.percentages.hasOwnProperty(i) && this.percentages[i].width > 0) {
          result.push(this.percentages[i]);
        }
      }
      return result;
    },
    percentage: function percentage() {
      var result = 0;
      for (var i in this.percentages) {
        if (this.percentages.hasOwnProperty(i) && this.percentages[i].width > 0) {
          result += this.percentages[i].width;
        }
      }
      return result;
    },
    iconClass: function iconClass() {
      switch (this.status) {
        case 'success':
          return 'el-icon-circle-check';
        case 'error':
        case 'exception':
          return 'el-icon-circle-close';
        case 'ongoing':
          return 'el-icon-loading';
      }
    }
  },
  methods: {
    getColor: function getColor(status) {
      var ret = void 0;
      switch (status) {
        case 'success':
          ret = '#13ce66';
          break;
        case 'exception':
        case 'error':
          ret = '#f56c6c';
          break;
        default:
          ret = '#20a0ff';
      }
      return ret;
    },
    barStyle: function barStyle(part, index, parts) {
      var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        backgroundColor: part.status ? this.getColor(part.status) : part.color,
        borderRadius: 'none',
        display: 'inline-block',
        position: 'relative'
      }, part);

      style.width = part.width + '%';

      if (parts.length === 1) {
        style.borderRadius = '100px';
      }

      if (parts.length > 1 && index === 0) {
        style.borderRadius = '100px 0 0 100px';
      }

      if (parts.length > 1 && index + 1 === parts.length) {
        style.borderRadius = '0 100px 100px 0';
      }

      return style;
    }
  }
});

/***/ }),

/***/ 1436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjProgress_vue__ = __webpack_require__(1388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17698c40_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjProgress_vue__ = __webpack_require__(1439);
function injectStyle (ssrContext) {
  __webpack_require__(1437)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17698c40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjProgress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17698c40_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjProgress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1437:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1438);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6cddd4f7", content, true, {});

/***/ }),

/***/ 1438:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".el-progress.is-error .el-progress__text[data-v-17698c40]{color:#f56c6c}.el-progress-bar[data-v-17698c40]{padding-right:30px;margin-right:-30px}", "", {"version":3,"sources":["/workspace/src/components/sj-progress/SjProgress.vue"],"names":[],"mappings":"AACA,0DAA0D,aAAa,CACtE,AACD,kCAAkC,mBAAmB,kBAAkB,CACtE","file":"SjProgress.vue","sourcesContent":["\n.el-progress.is-error .el-progress__text[data-v-17698c40]{color:#f56c6c\n}\n.el-progress-bar[data-v-17698c40]{padding-right:30px;margin-right:-30px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-progress",class:[
    'el-progress--' + _vm.type,
    _vm.status ? 'is-' + _vm.status : '',
    {
      'el-progress--without-text': _vm.status === '',
      'el-progress--text-inside': _vm.status === '',
    }
  ],attrs:{"role":"progressbar","aria-valuenow":_vm.percentage,"aria-valuemin":"0","aria-valuemax":"100"}},[(_vm.type === 'line')?_c('div',{staticClass:"el-progress-bar"},[_c('div',{staticClass:"el-progress-bar__outer",style:({height: _vm.strokeWidth + 'px'})},_vm._l((_vm.barParts),function(part,index){return _c('div',{staticClass:"el-progress-bar__inner",style:(_vm.barStyle(part, index, _vm.barParts))},[(_vm.showText && _vm.textInside)?_c('div',{staticClass:"el-progress-bar__innerText"},[_vm._v(_vm._s(part.width)+"%\n        ")]):_vm._e()])}),0)]):_vm._e(),_vm._v(" "),(_vm.status)?_c('div',{staticClass:"el-progress__text"},[_c('i',{class:_vm.iconClass})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_downloadjs__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_downloadjs__);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    onDownErrorFile: function onDownErrorFile(id) {
      __WEBPACK_IMPORTED_MODULE_0_downloadjs___default()(request.items.downErrorFile(id));
    },
    taskBatchPercentage: function taskBatchPercentage(row) {
      var parts = [];
      if (row.total_count <= 0) {
        return parts;
      }

      var success = 0;
      var error = 0;

      if (row.success_count > 0) {
        success = Math.round(row.success_count * 100 / row.total_count);
      }

      if (row.error_count > 0) {
        error = Math.round(row.error_count * 100 / row.total_count);
      }

      if (success + error > 100) {
        error = 100 - success;
      }

      if (success > 0) {
        parts.push({
          width: success,
          status: 'default'
        });
      }

      if (error > 0) {
        parts.push({
          width: error,
          status: 'error'
        });
      }

      return parts;
    },
    taskBatchStatus: function taskBatchStatus(row) {
      switch (row.status) {
        case 1:
        case 2:
          return 'ongoing';
        case 3:
          return 'success';
        case -1:
        case -2:
        case -3:
        case -4:
          return 'error';
      }
    }
  }
});

/***/ }),

/***/ 1444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SjProgress__ = __webpack_require__(1436);


__WEBPACK_IMPORTED_MODULE_0__SjProgress__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__SjProgress__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__SjProgress__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__SjProgress__["a" /* default */]);

/***/ }),

/***/ 1512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xlsx__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      archivedFields: [{
        prop: 'taskid',
        label: '任务ID',
        formatter: function formatter(row) {
          return 'TSK' + row.taskid;
        }
      }, {
        prop: 'title',
        label: '任务标题'
      }, {
        prop: 'type',
        label: '任务类型',
        formatter: function formatter(row) {
          return _this.getOptionLabel('allType', row.type);
        }
      }, {
        prop: 'assignnum',
        label: '完成人'
      }, {
        prop: 'salary',
        label: '赏金',
        formatter: function formatter(row) {
          return filter.hasPermission(250) ? row.salary : '*';
        }
      }, {
        prop: 'starttime_endtime',
        label: '任务时间',
        formatter: function formatter(row) {
          return row.starttime + '\n' + row.endtime;
        },
        width: '160px'
      }, {
        prop: 'city',
        label: '城市',
        formatter: function formatter(row) {
          return '' + row.provincename + row.cityname + row.areaname;
        }
      }, {
        prop: 'marketname',
        label: '门店名称'
      }, {
        prop: 'status',
        label: '任务状态',
        formatter: function formatter(row) {
          return _this.getOptionLabel('status', row.status);
        }
      }, {
        prop: 'adminname',
        label: '任务发布人'
      }, {
        prop: 'customerid',
        label: '所属客户',
        formatter: function formatter(row) {
          return row.customerid ? row.customer_name + '/' + row.customer_number : '平台';
        }
      }, {
        prop: 'publishtime',
        label: '发布时间',
        formatter: function formatter(row) {
          return '' + row.publishtime;
        },
        width: '160px'
      }],
      orderArchivedFields: [{
        prop: 'orderid',
        label: '工单ID',
        formatter: function formatter(row) {
          return 'ORD' + row.orderid;
        }
      }, {
        prop: 'title',
        label: '任务标题'
      }, {
        prop: 'type',
        label: '任务类型',
        formatter: function formatter(row) {
          return _this.getOptionLabel('allType', row.type);
        }
      }, {
        prop: 'userid',
        label: '完成人'
      }, {
        prop: 'salary',
        label: '赏金',
        formatter: function formatter(row) {
          return filter.hasPermission(250) ? row.salary : '*';
        }
      }, {
        prop: 'starttime_endtime',
        label: '任务时间',
        formatter: function formatter(row) {
          return row.starttime + '\n' + row.endtime;
        },
        width: '160px'
      }, {
        prop: 'city',
        label: '城市',
        formatter: function formatter(row) {
          return '' + row.provincename + row.cityname + row.areaname;
        }
      }, {
        prop: 'marketname',
        label: '门店名称'
      }, {
        prop: 'status',
        label: '任务状态',
        formatter: function formatter(row) {
          return _this.getOptionLabel('status', row.status);
        }
      }, {
        prop: 'adminname',
        label: '任务发布人'
      }, {
        prop: 'customerid',
        label: '所属客户',
        formatter: function formatter(row) {
          return row.customerid ? row.customer_name + '/' + row.customer_number : '平台';
        }
      }, {
        prop: 'review',
        label: '审核次数'
      }, {
        prop: 'publishtime',
        label: '发布/更新时间',
        formatter: function formatter(row) {
          return row.publishtime + '\n' + (row.lastupdatetime || '');
        },
        width: '160px'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  })),
  methods: {
    onUploadFile: function onUploadFile(file, taskType) {
      var _this2 = this;

      var fileType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;

      var isLt10M = file.raw.size / 1024 / 1024 < 10;
      if (taskType === 231) {
        fileType = 8;
      }

      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        this.$refs.upload.clearFiles();
        return false;
      }

      var formData = new FormData();
      formData.append('file', file.raw);
      formData.append('collection_type', 2); // 集合类型为2
      formData.append('type', taskType);
      formData.append('file_type', fileType);

      request.common('createTaskBatch', formData).then(function (_ref) {
        var data = _ref.data;

        _this2.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this2.onSearch();
      });
    },
    createTaskBatch: function createTaskBatch(file) {
      var _this3 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('createTaskBatchJob', formData).then(function (_ref2) {
        var data = _ref2.data;

        _this3.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this3.onSearch();
      });
    },
    createTaskBatchWithTemplate: function createTaskBatchWithTemplate(file) {
      var _this4 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('createTaskWithTemplateBatchJob', formData).then(function (_ref3) {
        var data = _ref3.data;

        _this4.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this4.onSearch();
      });
    },
    uploadAuditReferenceBatch: function uploadAuditReferenceBatch(file) {
      var _this5 = this;

      var isLt10M = file.raw.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        return false;
      }
      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('importTaskAuditReferenceBatchJob', formData).then(function () {
        _this5.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this5.onSearch();
      });
    },
    editTaskBatch: function editTaskBatch(file) {
      var _this6 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('editTaskBatchJob', formData).then(function (_ref4) {
        var data = _ref4.data;

        _this6.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this6.onSearch();
      });
    },
    deleteTaskBatch: function deleteTaskBatch(file) {
      var _this7 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('deleteTaskBatchJob', formData).then(function (_ref5) {
        var data = _ref5.data;

        _this7.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this7.onSearch();
      });
    },
    reactivateTaskBatch: function reactivateTaskBatch(file) {
      var _this8 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('reactivateTaskBatchJob', formData).then(function (_ref6) {
        var data = _ref6.data;

        _this8.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this8.onSearch();
      });
    },

    // 解析上传的excel文件 看一下是否超过MaxRowLimit
    parseExcelFile: function parseExcelFile(file) {
      var maxRowLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20000;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var isSatisfy = true;
        var errorMessage = '';
        // 先校验一下文件的大小
        var isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          isSatisfy = false;
          errorMessage = '上传表格行数超过10M，可能引起性能故障并导致更新失败。请与产品联系后上传，产品开发将关注后续更新情况。';
          return resolve({ isSatisfy: isSatisfy, errorMessage: errorMessage });
        }
        var reader = new FileReader();
        reader.onload = function (e) {
          try {
            var data = new Uint8Array(e.target.result);
            var workbook = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.read(data, { type: 'array' });

            var firstSheetName = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[firstSheetName];

            var jsonData = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.utils.sheet_to_json(worksheet, { header: 1 });
            // 计算数据条数，减去第一行标题
            var rowCount = jsonData.length - 1;
            // 超过限定的长度
            if (rowCount > maxRowLimit) {
              isSatisfy = false;
              errorMessage = '\u4E0A\u4F20\u8868\u683C\u884C\u6570\u8D85\u8FC7' + maxRowLimit + '\u6761\uFF0C\u53EF\u80FD\u5F15\u8D77\u6027\u80FD\u6545\u969C\u5E76\u5BFC\u81F4\u66F4\u65B0\u5931\u8D25\u3002\u8BF7\u4E0E\u4EA7\u54C1\u8054\u7CFB\u540E\u4E0A\u4F20\uFF0C\u4EA7\u54C1\u5F00\u53D1\u5C06\u5173\u6CE8\u540E\u7EED\u66F4\u65B0\u60C5\u51B5\u3002';
            } else {
              isSatisfy = true;
            }
            return resolve({ isSatisfy: isSatisfy, errorMessage: errorMessage });
          } catch (error) {
            reject(Error('\u6587\u4EF6\u89E3\u6790\u5931\u8D25: ' + error.message));
            throw new Error(error);
          }
        };
        reader.onerror = function () {
          reject(Error('文件读取失败'));
        };
        reader.readAsArrayBuffer(file);
      });
    },

    // 上传任务可执行时间段 需要先校验一下他的行数
    taskAvailableTimeBatch: function taskAvailableTimeBatch(file) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref7, isSatisfy, errorMessage;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this9.$store.commit('OPEN_LOADING');
                _context.next = 4;
                return _this9.parseExcelFile(file.raw, 20000);

              case 4:
                _ref7 = _context.sent;
                isSatisfy = _ref7.isSatisfy;
                errorMessage = _ref7.errorMessage;

                _this9.$store.commit('CLOSE_LOADING');
                // 超过限制 提示

                if (isSatisfy) {
                  _context.next = 22;
                  break;
                }

                _context.prev = 9;
                _context.next = 12;
                return _this9.$confirm(errorMessage, '警告', {
                  type: 'warning',
                  confirmButtonText: '已联系，继续操作',
                  cancelButtonText: '取消'
                });

              case 12:
                _context.next = 14;
                return _this9.uploadTaskAvailableTimeBatch(file);

              case 14:
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](9);

                _this9.$message.info('已取消上传');
                throw new Error(_context.t0);

              case 20:
                _context.next = 24;
                break;

              case 22:
                _context.next = 24;
                return _this9.uploadTaskAvailableTimeBatch(file);

              case 24:
                _context.next = 30;
                break;

              case 26:
                _context.prev = 26;
                _context.t1 = _context['catch'](0);

                _this9.$message.error(_context.t1);
                throw new Error(_context.t1);

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9, [[0, 26], [9, 16]]);
      }))();
    },

    // 上传excel
    uploadTaskAvailableTimeBatch: function uploadTaskAvailableTimeBatch(file) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = new FormData();

                formData.append('file', file.raw);
                _context2.next = 4;
                return request.common('taskAvailableTimeBatchJob', formData);

              case 4:
                _this10.$message({
                  showClose: true,
                  message: '上传成功',
                  type: 'success'
                });
                _this10.onSearch();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this10);
      }))();
    },

    // 任务可执行时间端 点击
    confirmTaskAvailableTimeBatch: function confirmTaskAvailableTimeBatch(e) {
      e.stopPropagation();
      this.$refs['upload'].$refs['upload-inner'].handleClick();
    },
    onPublishTask: function onPublishTask(task) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var totalSalary;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!moment(task.taskendtime).isBefore(moment())) {
                  _context3.next = 4;
                  break;
                }

                _this11.$message.error('任务结束时间必须大于当前时间');
                _context3.next = 15;
                break;

              case 4:
                totalSalary = _.round(task.hirenum * task.salary, 2);
                _context3.next = 7;
                return _this11.$prompt('\u4EFB\u52A1[' + task.taskid + ']\u7684\u62A5\u916C' + task.salary + '\u5143\uFF0C\u9700\u8981' + task.hirenum + '\u4EBA\uFF0C\u8BF7\u8F93\u5165\u603B\u91D1\u989D\uFF1A' + totalSalary, '提示', {
                  confirmButtonText: '发布',
                  cancelButtonText: '取消',
                  inputPattern: new RegExp('^' + totalSalary + '$'),
                  inputErrorMessage: '金额输入错误',
                  inputPlaceholder: totalSalary,
                  closeOnClickModal: false
                });

              case 7:
                _context3.next = 9;
                return request.alert('taskPublish', { taskid: task.taskid });

              case 9:
                _this11.$store.commit('OPEN_LOADING');
                _context3.next = 12;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                  setTimeout(function () {
                    resolve();
                    _this11.$store.commit('CLOSE_LOADING');
                  }, 2000);
                });

              case 12:
                _context3.next = 14;
                return _this11.onRefresh();

              case 14:

                _this11.$message({
                  showClose: true,
                  message: '\u4EFB\u52A1[' + task.taskid + ']\u53D1\u5E03\u6210\u529F',
                  type: 'success'
                });

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this11);
      }))();
    },
    getOptionLabel: function getOptionLabel(optType, val) {
      var type = this.options[optType].find(function (one) {
        return one.value === val;
      });
      return type ? type.label : '';
    },
    countDown: function countDown(date) {
      var futureTs = (Date.parse(date) + '').substr(0, 10);
      var currentTs = (new Date().getTime() + '').substr(0, 10);
      var interval = futureTs - currentTs;

      if (interval < 0) {
        return '';
      }

      return filter.formatTimerHumanize(interval);
    }
  }
});

/***/ }),

/***/ 1527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return taskTypes; });
var taskTypes = {
  BATCH_OPEN_TASK_GROUP_BY_SEARCH: { value: 56, label: '按搜索结果异步开启目标数' },
  BATCH_CLOSE_TASK_GROUP_BY_SEARCH: { value: 57, label: '按搜索结果异步关闭目标数' },
  USER_TAG_BY_CELLPHONE_SHA256: { value: 266, label: '批量标签池操作(按手机号sha256)' },
  BATCH_EXPORT_RECORD_REMARK: { value: 267, label: '录音标记批量导出' },
  BATCH_EXPORT_USER_AUDIT_WORKINFO: { value: 268, label: '按搜索条件导出用户职业信息' },
  BATCH_UPDATE_TASK_AFTER_MARKET_MODIFIED: { value: 269, label: '门店修改后更新任务属性' },
  BATCH_EXPORT_ORDER_SNEAK_SIMILARITY: { value: 270, label: '导出工单抓拍照片对比相似度数据' },
  BATCH_EXPORT_USER_COVERAGE_BY_MARKET_ID: { value: 271, label: '按门店ID批量导出零工覆盖指数' },
  BATCH_EXPORT_USER_COVERAGE_BY_GEO: { value: 272, label: '按经纬度批量导出零工覆盖指数' },
  BATCH_ADD_TAG_BY_CONDITION: { value: 273, label: '按搜索条件查找用户并添加标签' },
  BATCH_DEL_TAG_BY_CONDITION: { value: 274, label: '按搜索条件查找用户并删除标签' },
  BATCH_SUGGEST_PRICE_AND_CREATE_TASK: { value: 276, label: '计算门店任务建议定价并创建任务' },
  BATCH_EXPORT_LOW_SCORE_ORDER_FACE: { value: 280, label: '人脸识别分值导出' },
  BATCH_CREATE_TASK_WITH_TEMPLATE: { value: 281, label: '批量添加任务之替换选模版说明' },
  BATCH_REACTIVE_TASK: { value: 282, label: '批量重新上线任务' },
  BATCH_ORDER_EXPORT_NEW: { value: 283, label: '新版批量导出工单' },
  BATCH_EXPIRE_WORKINFO: { value: 284, label: '批量过期用户职业信息' },
  BATCH_SYNC_PERSONNEL_REQUIREMENT: { value: 285, label: '批量同步批次人员要求到任务' },
  BATCH_TASK_ORDER_EXPORT_NEW: { value: 286, label: '新版批量导出任务工单' },
  BATCH_TASK_EXPORT_NEW: { value: 287, label: '新版批量导出任务' },
  BATCH_BANQUET_TASK_IMPORT: { value: 288, label: '批量导入宴席任务' },
  BATCH_TASK_AUDIT_REFERENCE: { value: 289, label: '上传审核参照数据' }
};

/***/ }),

/***/ 2542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_task_task_mixins__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sj_progress__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_task_batch_task_batch_mixins__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__ = __webpack_require__(1527);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_2__views_task_task_mixins__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__views_task_batch_task_batch_mixins__["a" /* default */]],
  components: { SjProgress: __WEBPACK_IMPORTED_MODULE_3__components_sj_progress__["a" /* default */] },
  data: function data() {
    return {
      all_tasks: [{ 'value': 51, 'label': '上传群组门店关系', 'collection_id': 11 }, { 'value': 52, 'label': '群组设置目标数', 'collection_id': 11 }, { 'value': 53, 'label': '群组批量设置目标数', 'collection_id': 11 }, { 'value': 54, 'label': '群组门店关联(执行冲突更新)', 'collection_id': 11 }, { 'value': 55, 'label': '单群组设置目标数状态', 'collection_id': 11 }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_OPEN_TASK_GROUP_BY_SEARCH, { collection_id: 11 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_CLOSE_TASK_GROUP_BY_SEARCH, { collection_id: 11 }), { 'value': 200, 'label': '批量添加分步模板之替换、选题', 'collection_id': 2 }, { 'value': 201, 'label': '批量向用户添加teke标签属性', 'collection_id': 6 }, { 'value': 202, 'label': '批量向用户删除teke标签属性', 'collection_id': 6 }, { 'value': 203, 'label': '批量修改teke标签', 'collection_id': 6 }, { 'value': 204, 'label': '上传teke标签库(包含批量创建teke标签以及批量添加用户)', 'collection_id': 6 }, { 'value': 205, 'label': '批量导出teke标签', 'collection_id': 6 }, { 'value': 206, 'label': '批量上传活动奖品', 'collection_id': 7 }, { 'value': 207, 'label': '批量提现（银行卡/支付宝）', 'collection_id': 5 }, { 'value': 208, 'label': '批量任务价格调整（调价批次）', 'collection_id': 2 }, { 'value': 209, 'label': '批量添加门店', 'collection_id': 3 }, { 'value': 210, 'label': '批量更新门店', 'collection_id': 3 }, { 'value': 211, 'label': '批量更新门店(不覆盖)', 'collection_id': 3 }, { 'value': 212, 'label': '批量添加平台用户角色', 'collection_id': 8 }, { 'value': 213, 'label': '批量删除平台用户角色', 'collection_id': 8 }, { 'value': 214, 'label': '批量提现上传批量回滚', 'collection_id': 5 }, { 'value': 215, 'label': '按批次通过工单', 'collection_id': 2 }, { 'value': 216, 'label': '按批次回收工单', 'collection_id': 2 }, { 'value': 217, 'label': '批量添加任务', 'collection_id': 11 }, { 'value': 218, 'label': '批量修改任务', 'collection_id': 11 }, { 'value': 219, 'label': '批量修改任务可执行时间', 'collection_id': 11 }, { 'value': 221, 'label': '按批次审核工单', 'collection_id': 2 }, { 'value': 222, 'label': '批量复制任务更改门店', 'collection_id': 11 }, { 'value': 223, 'label': '批量门店统计覆盖查询', 'collection_id': 3 }, { 'value': 224, 'label': '批量零豆操作', 'collection_id': 1 }, { 'value': 225, 'label': '批量标签操作(按手机号)', 'collection_id': 1 }, { 'value': 226, 'label': '批量标签操作(注册)', 'collection_id': 1 }, { 'value': 227, 'label': '批量修改用户能力&超级零工属性', 'collection_id': 1 }, { 'value': 228, 'label': '批量封号', 'collection_id': 1 }, { 'value': 229, 'label': '批量修改用户职业属性', 'collection_id': 1 }, { 'value': 230, 'label': '批量删除任务', 'collection_id': 2 }, { 'value': 231, 'label': '批量添加分步模板', 'collection_id': 2 }, { 'value': 232, 'label': '批量修改赏金操作', 'collection_id': 1 }, { 'value': 233, 'label': '批量更新平台用户邮箱', 'collection_id': 8 }, { 'value': 234, 'label': '批量更新分步模板对应的任务', 'collection_id': 2 }, { 'value': 236, 'label': '批量导出任务', 'collection_id': 11 }, { 'value': 237, 'label': '批量导出工单', 'collection_id': 11 }, { 'value': 238, 'label': '批量导出任务工单', 'collection_id': 11 }, { 'value': 239, 'label': '批量导出零工账户信息', 'collection_id': 1 }, { 'value': 240, 'label': '批量增加项目批次', 'collection_id': 9 }, { 'value': 241, 'label': '批量添加零工用户', 'collection_id': 1 }, { 'value': 242, 'label': '批量修改零工用户', 'collection_id': 1 }, { 'value': 243, 'label': '批量微信提现', 'collection_id': 5 }, { 'value': 246, 'label': '批量更新城市单价（区域管理）', 'collection_id': 3 }, { 'value': 249, 'label': '导出零工当前提现金额', 'collection_id': 1 }, { 'value': 250, 'label': '导出零工当前账户余额', 'collection_id': 1 }, { 'value': 255, 'label': '批量自选职业添加用户', 'collection_id': 1 }, { 'value': 256, 'label': '批量自选职业移除用户', 'collection_id': 1 }, { 'value': 257, 'label': '批量导出用户(按手机号)', 'collection_id': 1 }, { 'value': 258, 'label': '批量导出用户(按ID)', 'collection_id': 1 }, { 'value': 259, 'label': '批量导出门店', 'collection_id': 3 }, { 'value': 260, 'label': '批量标签操作(按ID)', 'collection_id': 1 }, { 'value': 261, 'label': '批量导出省市区关系', 'collection_id': 11 }, { 'value': 262, 'label': '按工单解冻oss文件链接', 'collection_id': 2 }, { 'value': 263, 'label': '批量添加实习生', 'collection_id': 8 }, { 'value': 264, 'label': '批量修改实习生', 'collection_id': 8 }, { 'value': 265, 'label': '职业信息批量驳回', 'collection_id': 1 }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].USER_TAG_BY_CELLPHONE_SHA256, { collection_id: 1 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_EXPORT_RECORD_REMARK, { collection_id: 11 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_EXPORT_USER_AUDIT_WORKINFO, { collection_id: 11 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_UPDATE_TASK_AFTER_MARKET_MODIFIED, { collection_id: 11 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_EXPORT_ORDER_SNEAK_SIMILARITY, { collection_id: 11 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_EXPORT_USER_COVERAGE_BY_MARKET_ID, { collection_id: 11 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_EXPORT_USER_COVERAGE_BY_GEO, { collection_id: 11 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_ADD_TAG_BY_CONDITION, { collection_id: 11 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_DEL_TAG_BY_CONDITION, { collection_id: 11 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_SUGGEST_PRICE_AND_CREATE_TASK, { collection_id: 11 }), { 'value': 277, 'label': '批量添加职业信息公司', 'collection_id': 12 }, { 'value': 278, 'label': '批量添加职业信息工种', 'collection_id': 12 }, { 'value': 279, 'label': '批量修改目标数', 'collection_id': 13 }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_ORDER_EXPORT_NEW, { collection_id: 11 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_EXPIRE_WORKINFO, { collection_id: 12 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_SYNC_PERSONNEL_REQUIREMENT, { collection_id: 2 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_TASK_ORDER_EXPORT_NEW, { collection_id: 11 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_TASK_EXPORT_NEW, { collection_id: 11 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_TASK_AUDIT_REFERENCE, { collection_id: 11 })],
      all_collections: [{ 'collection_id': 1, 'collection_name': '用户相关任务(id: 1)' }, { 'collection_id': 2, 'collection_name': '任务相关任务(id: 2)' }, { 'collection_id': 3, 'collection_name': '卖场相关任务(id: 3)' }, { 'collection_id': 5, 'collection_name': '财务相关任务(id: 5)' }, { 'collection_id': 6, 'collection_name': 'teke标签任务(id: 6)' }, { 'collection_id': 7, 'collection_name': '活动相关任务(id: 7)' }, { 'collection_id': 8, 'collection_name': '管理账号相关任务(id: 8)' }, { 'collection_id': 9, 'collection_name': '客户相关任务(id: 9)' }, { 'collection_id': 10, 'collection_name': '中台任务(id: 10)' }, { 'collection_id': 11, 'collection_name': '队列任务(id: 11)' }, { 'collection_id': 12, 'collection_name': '职业信息相关任务(id: 12)' }, { 'collection_id': 13, 'collection_name': '统计管理相关任务(id: 13)' }],
      search: {
        task_type: null,
        collection_type: null,
        status: null
      },
      searchFieldType: {
        task_type: Number,
        collection_type: Number,
        status: Number
      }
    };
  },

  computed: Vuex.mapState({
    status: function status(state) {
      return state.taskBatch.status;
    }
  }),
  created: function created() {},

  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    getTableData: function getTableData(params) {
      return request.common('queryWaitProcessJobsApi', params);
    },
    handleTaskClick: function handleTaskClick(taskId, collectionId) {
      window.location.href = '?task_type=' + taskId + '&collection_type=' + collectionId;
    },
    handleCollectionClick: function handleCollectionClick(collectionId) {
      window.location.href = '?collection_type=' + collectionId;
    },
    handleCustomerClick: function handleCustomerClick(customerId) {
      window.location.href = '?customerid=' + customerId;
    },
    onChangeSelectTaskType: function onChangeSelectTaskType(val) {
      if (val) {
        var selectedTask = this.all_tasks.find(function (task) {
          return task.value + '' === val + '';
        });
        if (selectedTask) {
          this.search.collection_type = selectedTask.collection_id;
        }
      } else {
        this.search.collection_type = null;
      }
    },
    onChangeSelectCollectionType: function onChangeSelectCollectionType(val) {
      if (val) {
        this.search.task_type = null;
      }
    }
  })
});

/***/ }),

/***/ 3289:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3290);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4d19c6d8", content, true, {});

/***/ }),

/***/ 3290:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".link-text[data-v-7b924f7a]{color:#409eff;text-decoration:none}.link-text[data-v-7b924f7a]:hover{text-decoration:underline}", "", {"version":3,"sources":["/workspace/src/views/batch-jobs/pages/AllBatchJobsTable.vue"],"names":[],"mappings":"AACA,4BAA4B,cAAc,oBAAoB,CAC7D,AACD,kCAAkC,yBAAyB,CAC1D","file":"AllBatchJobsTable.vue","sourcesContent":["\n.link-text[data-v-7b924f7a]{color:#409EFF;text-decoration:none\n}\n.link-text[data-v-7b924f7a]:hover{text-decoration:underline\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("所有批量任务")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"任务类型","prop":"task_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择","clearable":""},on:{"change":_vm.onChangeSelectTaskType},model:{value:(_vm.search.task_type),callback:function ($$v) {_vm.$set(_vm.search, "task_type", $$v)},expression:"search.task_type"}},_vm._l((_vm.all_tasks),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属队列","prop":"collection_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择","clearable":""},on:{"change":_vm.onChangeSelectCollectionType},model:{value:(_vm.search.collection_type),callback:function ($$v) {_vm.$set(_vm.search, "collection_type", $$v)},expression:"search.collection_type"}},_vm._l((_vm.all_collections),function(item){return _c('el-option',{key:item.collection_id,attrs:{"label":item.collection_name,"value":item.collection_id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态","prop":"status"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":""},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.status),function(ref){
var label = ref.label;
var value = ref.value;
return _c('el-option',{key:value,attrs:{"value":value,"label":label}})}),1)],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"sj-icon-export"},on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","min-width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"display_name","label":"名称","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"admin_name","label":"发起者","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.admin_name)+" ("+_vm._s(scope.row.admin_id)+")\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"上传时间","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"任务进度","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('sj-progress',{attrs:{"text-inside":true,"stroke-width":18,"status":_vm.taskBatchStatus(scope.row),"percentages":_vm.taskBatchPercentage(scope.row)}}),_vm._v("\n          成功:"+_vm._s(scope.row.success_count)+" 错误:"+_vm._s(scope.row.error_count)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"task_type","label":"任务类型","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.all_tasks),function(item){return (scope.row.task_type  + '' === item.value + '')?_c('span',[_c('a',{staticClass:"link-text",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.handleTaskClick(item.value, item.collection_id)}}},[_vm._v("\n              "+_vm._s(item.label)+"\n            ")])]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer_name","label":"客户","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.customer_id > 0)?_c('a',{staticClass:"link-text",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.handleCustomerClick(scope.row.customer_id)}}},[_vm._v("\n            "+_vm._s(scope.row.customer_name)+" / "+_vm._s(scope.row.customer_id)+"\n          ")]):_c('span',[_vm._v("\n            "+_vm._s(scope.row.customer_name)+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"collection_type","label":"所属队列","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.all_collections),function(item){return (scope.row.collection_type + '' === item.collection_id + '')?_c('span',[_c('a',{staticClass:"link-text",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.handleCollectionClick(item.collection_id)}}},[_vm._v("\n              "+_vm._s(item.collection_name)+"\n            ")])]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"状态","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.status),function(item){return (scope.row.status === item.value)?_c('span',[_vm._v(_vm._s(item.label)+"\n            ")]):_vm._e()})}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/all-batch-jobs-table.2565ec07d95efa54f04e.js